import { computed, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Query } from '@datorama/akita';

import { ChecklistToggleRow, ChecklistToggleState } from './checklist-toggle.model';
import { ChecklistToggleStore } from './checklist-toggle.store';

@Injectable({ providedIn: 'root' })
export class ChecklistToggleQuery extends Query<ChecklistToggleState> {
  allRows = toSignal(this.select(), { requireSync: true });

  protected store: ChecklistToggleStore;

  constructor() {
    const store = inject(ChecklistToggleStore);

    super(store);

    this.store = store;
  }

  isRowOpen(row: ChecklistToggleRow) {
    return computed(() => this.allRows()?.[row]);
  }
}
